import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Controller, useForm } from "react-hook-form";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from "reactstrap";
import Switch from "react-switch";
import Button from "../../layout/Button";
import { useDispatch, useSelector } from "react-redux";
import { BuisnessTypeExcel, EMPTY_DATA, defaultPageSize } from "../../../config/constants";
import NoContentFound from "../../common/NoContentFound";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import { PaginationWrapper } from "../../common/commonPagination";
import LoaderCustom from "../../common/LoaderCustom";
import DayTime from "../../common/DayTimeWrapper";
import { handleDepartmentHeader, searchNocontentFilter, setLoremIpsum, userDetails } from "../../../helper";
import DatePicker from "react-datepicker";
import CustomDateRangeFilter from "../supplierNewRequestHistory/common/CustomDateRangeFilter ";
import { reactLocalStorage } from "reactjs-localstorage";

import { exceptionApprovalAcceptReject, fetchExceptionalApprovalList } from "./Action";
import { SearchableSelectHookForm, TextAreaHookForm } from "../../layout/HookFormInputs";
import { getReasonAuditListing } from "../NsaAudit/Action";
import Toaster from "../../common/Toaster";
import { setSelectedRowForPagination } from "../../simulation/actions/Simulation";
import _ from "lodash";
import ReactExport from "react-export-excel";
import { BUISNESS_TYPE_EXCEL, EXCEPTION_APPROVAL_LIST_M } from "../../../config/masterData";
import { useHistory } from "react-router-dom";
import { ApplyPermissionExceptionApproval } from ".";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const ExceptionalApprovalList = (props) => {
  const permissionException = useContext(ApplyPermissionExceptionApproval);

  const dispatch = useDispatch();
  const history = useHistory();

  const formController = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  let {
    control: popFormControl,
    formState: { errors: popFormErrors },
    register: popFormRegister,
    handleSubmit,
    getValues,
    setValue,
    reset,

  } = formController;
  const [reasonAudit, setReasonAudit] = useState([]);
  const [dataCount, setDataCount] = useState(0);

  const [pageNo, setPageNo] = useState(1);
  const [showExceptionPopup, setShowExceptionPopup] = useState(false);
  const [currentExceptionApprovalRequest, setCurrentExceptionApprovalRequest] = useState(null);


  const [pageSize, setPageSize] = useState({
    pageSize10: true,
    pageSize50: false,
    pageSize100: false,
  });
  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });
  const [submitionLoading, setSubmitionLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [noData, setNoData] = useState(false);
  const [loader, setloader] = useState(false);
  const [globalTake, setGlobalTake] = useState(defaultPageSize);
  const [gridApi, setgridApi] = useState(null); // DONT DELETE THIS STATE , IT IS USED BY AG GRID
  const [gridColumnApi, setgridColumnApi] = useState(null);
  const [currentRowIndex, setCurrentRowIndex] = useState(0);
  const [excelStartDate, setexcelStartDate] = useState("");
  const [excelEndDate, setexcelEndDate] = useState("");

  const { ExceptionApprovalList } = useSelector((state) => state?.ExceptionApprovalListReducer);
  // 

  // const currentListQty = (ExceptionApprovalList?.data?.Page - 1) * globalTake;
  // let serialNumber = currentListQty + 1; // Start numbering from 1
  // const usersWithSerialNumbers = (ExceptionApprovalList?.data?.Data || []).map(
  //   (user, index) => {
  //     const updatedSerialNumber = serialNumber + index;
  //     return {
  //       ...user,
  //       serialNumber: updatedSerialNumber,
  //     };
  //   }
  // );
  const onBtPrevious = () => {
    if (currentRowIndex >= 10) {
      const previousNo = Math.max(0, currentRowIndex - 10);
      setCurrentRowIndex(previousNo);
      setPageNo((prevPageNo) => Math.max(1, prevPageNo - 1));

      getUsers(pageNo - 1, globalTake); // Fetch data for the previous page
    }
  };

  const onBtNext = () => {
    if (
      (pageSize.pageSize50 &&
        pageNo >= Math.ceil(ExceptionApprovalList?.data?.TotalItems / 50)) ||
      (pageSize.pageSize100 &&
        pageNo >= Math.ceil(ExceptionApprovalList?.data?.TotalItems / 100))
    ) {
      return false;
    }

    if (currentRowIndex < ExceptionApprovalList?.data?.TotalItems - 10) {
      const nextNo = currentRowIndex + 10;
      setCurrentRowIndex(nextNo);
      setPageNo((prevPageNo) => prevPageNo + 1);

      // Retrieve sorting information
      const sortModel = gridApi.getSortModel();
      const sort = sortModel.length > 0 ? sortModel[0].sort : "ASC";
      const colId = sortModel.length > 0 ? sortModel[0].colId : null;

      // Pass sorting information to getUsers function
      getUsers(pageNo + 1, globalTake, sort, colId);
    }
  };
  const closeExceptionPopUp = () => {
    setShowExceptionPopup(false);
  };
  const handleRequestForConfirmation = async (data, action) => {

    let empId = userDetails();

    try {
      setSubmitionLoading(true); // Set loading to true during submission
      const payload = {
        RequestNo: currentExceptionApprovalRequest?.ApplicationID,
        ExceptionalFlowRequestId: currentExceptionApprovalRequest?.ExceptionalFlowRequestId,
        Remarks: data?.RequestSentRemark,
        EmployeeId: parseInt(empId?.EmployeeId),
        Status: action === "Approved" ? "Approved" : "Rejected", // Determine the status based on the action
        // Define payload data here
      };

      // return;
      // Assuming dispatch is asynchronous, you can wait for it to complete using await
      const res = await new Promise((resolve) => {
        dispatch(exceptionApprovalAcceptReject(payload, resolve));
      });
      if (res && res?.IsSuccessful) {
        getUsers(pageNo, defaultPageSize, "ASC");
        setShowExceptionPopup(false);
        setValue("RequestSentRemark", "")
        // getUsers(parseInt(nsaAuditDetailId), parseInt(idData)); // Fetch updated data
        Toaster.success(res?.FriendlyMessage);
        // setValue("assignCFT", null);
      }
    } catch (error) {

      // setSubmitionLoading(false); // Set loading to false in case of an error
      // Toaster.error(error?.Res?.data?.ErrorMessage);
    } finally {
      // setShowExceptionPopup(false);
      // // setValue("assignCFT", " ");
      setSubmitionLoading(false); // Ensure loading is set to false even if an error occurs
    }
  };


  /**
  * @method onFloatingFilterChanged
  * @description Filter data when user type in searching input
  */
  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (ExceptionApprovalList?.data.length !== 0) {
        setState((prevState) => ({
          ...prevState,
          noData: searchNocontentFilter(value, prevState.noData),
        }));
      }
    }, 500);
  };
  const getUsers = async (
    currentPage,
    pageSize,
    sortOrder,
    fieldName,
    requestFromDate,
    requestToDate
  ) => {
    try {
      const userDetail = userDetails();
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchExceptionalApprovalList({
          current_page: currentPage,
          per_page: pageSize,
          EmployeeId: userDetail?.EmployeeId,
          sortOrder: sortOrder,
          sortField: fieldName,
          requestFromDate: requestFromDate,
          requestToDate: requestToDate,
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };

  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  const onBtExport = () => {
    let tempArr = state.gridApi && state.gridApi.getSelectedRows();
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : ExceptionApprovalList?.data
          ? ExceptionApprovalList?.data
          : [];
    return returnExcelColumn(EXCEPTION_APPROVAL_LIST_M, tempArr);
  };

  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={'Exception-Approval-List'}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={(col) => {
                if (ele.value === "IsActive") {
                  return col[ele.value] ? "Active" : "Inactive";
                } else {
                  return col[ele.value];
                }
              }}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  const resetState = () => {
    const searchBox = document.getElementById("filter-text-box");
    if (searchBox) {
      searchBox.value = "";
    }
    state.gridApi.setQuickFilter(null);
    state.gridApi.deselectAll();
    state.gridApi.setFilterModel(null);
    state.gridColumnApi.resetColumnState();
    setState((prevState) => ({ ...prevState, noData: false }));
  };
  useEffect(() => {
    // Function to fetch data after a 3-second delay
    const fetchDataWithDelay = async () => {
      // Show loader
      setloader(true);

      // Simulate loading for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 3000));

      try {
        // Fetch data after the delay
        await getUsers(pageNo, defaultPageSize, "ASC");
      } catch (error) {

      } finally {
        // Hide loader after fetching data or encountering an error
        setloader(false);
      }
    };
    getAssignAuditorListing();
    // Call fetchDataWithDelay function
    fetchDataWithDelay();
  }, []);

  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onGridReady = (params) => {
    window.screen.width >= 1600 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
  };

  const onPageSizeChanged = (newPageSize) => {
    state.gridApi.paginationSetPageSize(Number(newPageSize));
    // const pageSizeValue = Number(newPageSize);

    // if (![10, 50, 100].includes(pageSizeValue)) {
    //   return; // Don't proceed if the page size is not valid
    // }

    // // Reset the page number to 1
    // setPageNo(1);

    // // Calculate the new page number based on the total record count and the new page size
    // let newPageNo = 1;

    // // Make the API call with the new page size and updated page number
    // getUsers(newPageNo, pageSizeValue);

    // // Update the state to reflect the new page size
    // setPageSize({
    //   pageSize10: pageSizeValue === 10,
    //   pageSize50: pageSizeValue === 50,
    //   pageSize100: pageSizeValue === 100,
    // });

    // setGlobalTake(pageSizeValue);

    // // Update the grid's page size
    // gridApi.paginationSetPageSize(pageSizeValue);
  };
  const getAssignAuditorListing = () => {
    getReasonAuditListing()
      .then((res) => {
        setReasonAudit(res?.Data);
      })
      .catch(() => { });
  };
  const renderListing = (label) => {
    if (label === "auditScore") {
      return reasonAudit.map((typeofEstablishment) => ({
        value: typeofEstablishment.ReasonId,
        label: typeofEstablishment.ReasonName,
      }));
    }
  };

  const handleActionView = (props) => {
    const exceptionApprovalIdData = props?.data;

    setShowExceptionPopup(true);
    let oldValues = getValues();
    setCurrentExceptionApprovalRequest(exceptionApprovalIdData);

    let formData = {
      ...oldValues,
      ExceptionalFlowRequestId: {
        value: exceptionApprovalIdData?.ExceptionalFlowReasonID,
        label: exceptionApprovalIdData?.Reason,
      },
      RequestNo: exceptionApprovalIdData?.ApplicationID,
      ExpectedDateOfCorrection: exceptionApprovalIdData?.ExpectedDateofCorrection, // Updated key name with formatted date
    };

    reset(formData);
  };

  const buttonFormatter = (props) => {
    // let empId = userDetails();
    props.api.sizeColumnsToFit();
    const handleView = () => {
      // Extract necessary IDs
      const requestId = props.data?.VendorRequirementRegistrationId;
      const nSAAuditDetailId = props.data?.NSAAuditDetailId;
      // Construct the base URL
      let url = `view-supplier-need-form?VendorRequirementRegistrationId=${requestId}`;
      // Append NSAAuditDetailId if it exists and is greater than 0
      if (nSAAuditDetailId && nSAAuditDetailId > 0) {
        url += `&nsaAuditDetailId=${nSAAuditDetailId}`;
      }
      // Navigate to the constructed URL
      history.push(url);
    };
    return (
      <div>

        <button
          title="Approve Reject Exception"
          className="Approve mr-2 hl-exception-button"
          type="button"
          onClick={() => handleActionView(props)}
          disabled={!(props?.data?.IsAllowAction)}
        >
        </button>
        {permissionException?.View &&
          <button
            title="View"
            className="View mr-0"
            type="button"
            onClick={() => handleView()}
          // disabled={!(props?.data?.Status === "Under Review")}
          >
          </button>}
      </div>
    );
  };

  if (submitionLoading) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }
  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject,1 rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
        </label>
      </>
    );
  };

  const reasonRenderer = (props) => {
    let reasons = props?.data?.ExeptionalFlowReasonList;
    // const categories = props.value;
    const reasonCount = reasons.length;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

    if (reasonCount === 0) {
      return <span>No Reasons</span>;
    }

    if (reasonCount === 1) {
      return <span>{reasons[0]}</span>;
    }

    const visibleReasons = reasons.slice(0, 1); // Show only the first category
    const hiddenReasons = reasons.slice(1); // Hide the first category, rest will go in dropdown

    return (
      <div className="hl-category-count">
        <span className="hl-category-names">{visibleReasons}</span>
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle caret={false} className="hl-category-count-btn">
            +{reasonCount - 1} more
          </DropdownToggle>
          <DropdownMenu container="body" className="hl-cat-menu">
            {hiddenReasons?.map((reason, index) => (
              <DropdownItem
                key={index}
                className="hl-cat-menu-item"
              // onClick={() => handleDropdownItemClick(category)}
              >
                {reason}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };
  const checkBoxRenderer = (props) => {
    let selectedRowForPagination =
      reactLocalStorage.getObject("selectedRow").selectedRow;
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    if (selectedRowForPagination?.length > 0) {
      selectedRowForPagination.map((item) => {
        if (item.ApplicationID === props.node.data.ApplicationID) {
          props.node.setSelected(true);
        }
        return null;
      });
      return cellValue;
    } else {
      return cellValue;
    }
  };
  /**
   * @method effectiveDateFormatter
   * @description Renders buttons
   */
  const requestedOnFormatter = (props) => {
    const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
    return cell != null ? DayTime(cell).format('DD/MM/YYYY') : '-';
  }

  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    customFloatingFilter: CustomDateRangeFilter,
    statusButtonFormatter: statusButtonFormatter,
    effectiveDateFormatter: effectiveDateFormatter,
    requestedOnFormatter: requestedOnFormatter,
    reasonRenderer: reasonRenderer,
    // hyphenFormatter: hyphenFormatter,
    customNoRowsOverlay: NoContentFound,
    checkBoxRenderer: checkBoxRenderer,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };

  return (
    <>
      <>
        <>
          {loader && <LoaderCustom customClass="simulation-Loader" />}
          <Row className="ag-grid-react">
            <Col>
              <div
                className={`ag-grid-wrapper overlay-contain ${props?.ExceptionApprovalList && !noData
                  ? "master-approval-overlay"
                  : ""
                  } ${(ExceptionApprovalList?.data &&
                    ExceptionApprovalList?.data?.length <= 0) ||
                    noData
                    ? "overlay-contain"
                    : ""
                  }`}
              >
                <div
                  className={`ag-theme-material ${loader && "max-loader-height"
                    }`}
                >
                  {noData && (
                    <NoContentFound
                      title={EMPTY_DATA}
                      customClassName="no-content-found"
                    />
                  )}
                  <Row className={`filter-row-large`}>
                    <Col md="3" className="mb-2">
                      <h1>Exception Approval List</h1>
                    </Col>
                    <Col md="9" className="mb-3 d-flex justify-content-end">
                      <>
                        {permissionException?.Download &&
                          <ExcelFile
                            filename={"Exception-Approval-List"}
                            fileExtension={".xls"}
                            element={
                              <button
                                title={`Download ${state.dataCount === 0
                                  ? "All"
                                  : "(" + state.dataCount + ")"
                                  }`}
                                type="button"
                                className={"user-btn mr5 Tour_List_Download"}
                              >
                                <div className="download mr-1"></div>
                                {`${state.dataCount === 0
                                  ? "All"
                                  : "(" + state.dataCount + ")"
                                  }`}
                              </button>
                            }
                          >
                            {onBtExport()}
                          </ExcelFile>}

                      </>
                      <button type="button" className="user-btn Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                        <div className="refresh mr-0"></div>
                      </button>
                    </Col>
                  </Row>
                  {/* {state.isLoader ? (
                    <LoaderCustom customClass="loader-center" />
                  ) : ( */}
                  <AgGridReact
                    defaultColDef={defaultColDef}
                    floatingFilter={true}
                    domLayout="autoHeight"
                    rowData={
                      state.showExtraData && ExceptionApprovalList?.data
                        ? [
                          ...setLoremIpsum(ExceptionApprovalList?.data[0]),
                          ...ExceptionApprovalList?.data,
                        ]
                        : ExceptionApprovalList?.data
                    }
                    pagination={true}
                    paginationPageSize={defaultPageSize}
                    onGridReady={onGridReady}
                    gridOptions={gridOptions}
                    noRowsOverlayComponent={"customNoRowsOverlay"}
                    noRowsOverlayComponentParams={{
                      title: EMPTY_DATA,
                      imagClass: "imagClass",
                    }}
                    rowSelection={"multiple"}
                    suppressRowClickSelection={true}
                    onSelectionChanged={onRowSelect}
                    onFilterModified={onFloatingFilterChanged}
                    frameworkComponents={frameworkComponents}
                  >
                    <AgGridColumn
                      cellClass="has-checkbox"
                      // field="vendorRequirementRegistrationId"
                      field="ApplicationID"
                      floatingFilter={true}
                      headerName="Application No."
                      cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>
                    <AgGridColumn
                      field="SupplierCategory"
                      sortable={true}
                      unSortIcon={true}
                      filter={true}
                      floatingFilter={true}
                      headerName="Supplier Category"
                      comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                      }
                    // cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>
                    <AgGridColumn
                      field="SupplierName"
                      headerName="Supplier Name"
                      floatingFilter={true}
                      sortable={true}
                      unSortIcon={true}
                      comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                      }
                    // cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>
                    <AgGridColumn
                      field="PlantName"
                      floatingFilter={true}
                      sortable={true}
                      unSortIcon={true}
                      headerName="Plant"
                      comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                      }
                    // cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>
                    <AgGridColumn
                      field="ApplyDate"
                      headerName="Apply Date"
                      filter="agDateColumnFilter"
                      cellRenderer={"effectiveDateFormatter"}
                      filterParams={{
                        comparator: (filterDate, cellValue) => {
                          // Parse the cellValue string to a Date object
                          const cellDate = new Date(cellValue);
                          // Remove the time part from both dates to only compare the date part
                          const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                          const cellDateOnly = cellDate.setHours(0, 0, 0, 0);

                          if (cellDateOnly < filterDateOnly) return -1;
                          if (cellDateOnly > filterDateOnly) return 1;
                          return 0;
                        },
                        inRangeInclusive: true, // Include start and end values in the range
                        filterOptions: ["equals", "inRange"],
                        browserDatePicker: true,
                        closeOnApply: true,
                        minValidYear: 2000,
                      }}
                    ></AgGridColumn>
                    <AgGridColumn
                      field="NeedFormRequested"
                      floatingFilter={true}
                      sortable={false}
                      headerName="Need Form Requested"
                    // cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>
                    <AgGridColumn
                      field="Reason"
                      floatingFilter={true}
                      sortable={false}
                      headerName="Reason"
                      // cellRenderer={checkBoxRenderer}
                      cellRenderer={"reasonRenderer"}
                    ></AgGridColumn>
                    {/* <AgGridColumn
                      field="ExpectedDateofCorrection"
                      filter="agDateColumnFilter"
                      headerName="Expected Date of Correction"
                      cellRenderer={"effectiveDateFormatter"}
                      filterParams={{
                        comparator: (filterDate, cellValue) => {
                          // Parse the cellValue string to a Date object
                          const cellDate = new Date(cellValue);
                          // Remove the time part from both dates to only compare the date part
                          const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                          const cellDateOnly = cellDate.setHours(0, 0, 0, 0);
  
                          if (cellDateOnly < filterDateOnly) return -1;
                          if (cellDateOnly > filterDateOnly) return 1;
                          return 0;
                        },
                        inRangeInclusive: true, // Include start and end values in the range
                        filterOptions: ["equals", "inRange"],
                        browserDatePicker: true,
                        closeOnApply: true,
                        minValidYear: 2000,
                      }}
                    ></AgGridColumn> */}
                    <AgGridColumn
                      field="RequestedOn"
                      floatingFilter={true}
                      sortable={false}
                      headerName="Requested On"
                      cellRenderer='requestedOnFormatter'
                    ></AgGridColumn>
                    <AgGridColumn
                      field="Status"
                      sortable={false}
                      floatingFilter={true}
                      headerName="Status"
                    //  cellRenderer={checkBoxRenderer}
                    ></AgGridColumn>
                    <AgGridColumn
                      headerName="Actions"
                      sortable={false}
                      cellRenderer={"totalValueRenderer"}
                      type="rightAligned"
                      floatingFilter={false}
                    // tooltipComponent={'customTooltip'}
                    ></AgGridColumn>
                  </AgGridReact>
                  {/* )} */}
                  {/* Add a new AgGridColumn for buttons */}
                  {
                    <PaginationWrapper
                      gridApi={state.gridApi}
                      setPage={onPageSizeChanged}
                    />
                  }
                </div>
              </div>
            </Col>
          </Row>
          <PopupMsgWrapper
            isOpen={showExceptionPopup}
            firstButtonName="Accept"
            secondButtonName="Reject"
            customClass="hl-exception-popup hl-invite-supplier"
            closePopUp={closeExceptionPopUp}
            header="Exception Flow Request"
            message={
              <>
                <label className="text-start mb-3 mt-1"><strong>Requester Remark:</strong>{currentExceptionApprovalRequest?.RequesterRemark}</label>
                <form className="hl-re-audit-pop-up">
                  {/* <Row className="text-start mb-2">
                    <Col lg="12">
                      <SearchableSelectHookForm
                        label={`Reason`}
                        name={"ExceptionalFlowRequestId"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={popFormControl}
                        rules={{ required: true }}
                        register={popFormRegister}
                        options={renderListing("auditScore")}
                        handleChange={() => { }}
                        mandatory={true}
                        errors={popFormErrors.ExceptionalFlowRequestId}
                        disabled={true}
                      />
                    </Col>

                    <div className="inputbox date-section">
                      <DatePicker
                        label="Expected Date of Correction"
                        selected={
                          currentExceptionApprovalRequest && currentExceptionApprovalRequest.ExpectedDateofCorrection
                            ? DayTime(
                              currentExceptionApprovalRequest.ExpectedDateofCorrection,
                              "YYYY-MM-DDTHH:mm:ss"
                            ).toDate()
                            : null
                        }
                        disabled={true}
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                  </Row> */}
                  <TextAreaHookForm
                    label={`Remarks`}
                    name={"RequestSentRemark"}
                    Controller={Controller}
                    control={popFormControl}
                    register={popFormRegister}
                    placeholder={"Enter"}
                    rules={{
                      required: "Remarks are required.",
                      maxLength: {
                        value: 250, // Adjusted to allow 250 characters
                        message: "Remarks cannot exceed 250 characters.",
                      },
                    }}
                    handleChange={() => { }}
                    errors={popFormErrors.RequestSentRemark}
                    customClassName={"withBorder"}
                    mandatory={true}
                  />
                  <div className="modal-footer">
                    <div className="p-relative">
                      <button type="button" className="approve-button mr5 approve-hover-btn" onClick={() => handleSubmit(handleRequestForConfirmation)("Approved")} >
                        <div className="save-icon"></div>Accept
                      </button>
                    </div>{" "}
                    <button type="button" className="approve-reject-btn" onClick={() => handleSubmit(handleRequestForConfirmation)("Rejected")} >
                      <div className="cancel-icon-white mr5"></div>Reject
                    </button>
                  </div>
                </form>
              </>
            }
          />
        </>
      </>
    </>
  );
};
export default ExceptionalApprovalList;
